module.exports = require('ember-lazy-list').LazyItemView.extend(require('./option-view-mixin'));